export default __webpack_public_path__ + "static/media/your-order.59bb3bb7.png";